import Control from "ol/control/Control";
import { DateTime } from "luxon";

export class DateInputControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement("ul");
    super({
      element: element,
      target: options.target,
    });

    const this_ = this;
    element.className = "date-input ol-unselectable";
    let li;

    // dates
    const inputStart = document.createElement("input");
    inputStart.type = "date";
    inputStart.value = DateTime.utc()
      .startOf("month")
      .minus({ weeks: 1 })
      .toISODate();
    li = document.createElement("li");
    li.appendChild(inputStart);
    element.appendChild(li);

    const inputEnd = document.createElement("input");
    inputEnd.type = "date";
    inputEnd.value = DateTime.utc().startOf("month").toISODate();
    li = document.createElement("li");
    li.appendChild(inputEnd);
    element.appendChild(li);

    const button = document.createElement("button");
    button.innerHTML = "Update";
    button.addEventListener(
      "click",
      function () {
        this_.setProperties({
          startDate: inputStart.value,
          endDate: inputEnd.value,
        });
      },
      false,
    );
    li = document.createElement("li");
    li.appendChild(button);
    element.appendChild(li);

    // initialize values
    this.setProperties({
      startDate: inputStart.value,
      endDate: inputEnd.value,
    });

    // listen to changes
    this.on("propertychange", () => {
      inputStart.value = this_.get("startDate");
      inputEnd.value = this_.get("endDate");
    });
  }
}
